/**
 * Returns true if the current page load was a browser refresh (vs. an SPA navigation).
 *
 * Uses the Navigation Timing API which directly reports the navigation type,
 * avoiding the need to infer reload status from application state.
 */
export function detectPageReload(): boolean {
  const navEntries = performance.getEntriesByType(
    "navigation",
  ) as PerformanceNavigationTiming[];
  return navEntries[0]?.type === "reload";
}
